// extracted by mini-css-extract-plugin
export default {"err":"MyText_err__Q-6pK"};